export default {
  prepareSequenceImages: Array(35)
    .fill('')
    .map((v, i) =>
    require(`../../../Box_sequences/Bespoke_Cube70/bespoke70_${i < 10 ? `0${i}` : i}.jpg`)
    ),
  designSliderImage: require('../../../product drawing/cube70/shoerack.png'),
  designImageList: [
    {
      number: 1,
      side: 'RIGHT',
      image: require('../../../parts/shoerackA/01.png'),
    },
    {
      number: 2,
      side: 'LEFT',
      image: require('../../../parts/shoerackA/02.png'),
    },
    {
      number: 3,
      side: 'FRONT',
      image: require('../../../parts/shoerackA/03.png'),
    },
    {
      number: '4',
      side: 'BACK',
      image: require('../../../parts/shoerackA/04.png'),
    },
  ],
  cutOutPartsImage: require('../../../parts/shoerackA/05.png'),
  assembleSequenceImages: Array(35)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/30_shoerack_A/shoerackA${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  completeImage: require('../../../complete/shoe rack_A.png'),
  completeImagePc: require('../../../complete/shoe rack_A.png'),
};
